import { THRESHOLD_COLOR_DEFAULT } from '../constants.js';
import type { GaugeChartThresholdIndicatorProps } from '../slots/ThresholdIndicator.js';
import type { GaugeChartThresholdIndicatorPropsInternal } from '../types/gauge-chart-config-internal.js';

export const applyThresholdDefaults = (
  threshold: GaugeChartThresholdIndicatorProps,
): GaugeChartThresholdIndicatorPropsInternal => {
  const showIndicatorDefault = threshold.color === undefined;

  return {
    value: threshold.value,
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    showIndicator: threshold.showIndicator ?? showIndicatorDefault,
    color: threshold.color ?? THRESHOLD_COLOR_DEFAULT,
  };
};
